@if (warningBannerWidget) {
  <div class="alert-banner-widget-wrapper">
    <div class="alert-banner">
      <p class="alert-banner-text">
        {{ labelsAlertBanner?.text }}
        @if (this.userRole) {
          <a class="alert-banner-link" (click)="onAlertBannerNavigate()">{{
            labelsAlertBanner?.link
          }}</a>
        } @else {
          <p class="alert-banner-contact">{{ labelsAlertBanner?.link }}</p>
        }
      </p>
    </div>
  </div>
}
